import type { HonorJobResponse } from "./types/honor-careers";

import { marketingApiGet } from "./marketing-api-get";

const DIGITS_ONLY_PATTERN = /^\d+$/;

type GetHonorJobOptions = {
  throwOnError?: boolean;
};

function parseHonorJobId(jobId: string): number | null {
  if (!DIGITS_ONLY_PATTERN.test(jobId)) {
    return null;
  }

  const parsed = Number(jobId);
  if (!Number.isInteger(parsed) || parsed < 1) {
    return null;
  }

  return parsed;
}

async function getHonorJob(
  jobId: string,
  options: GetHonorJobOptions = {},
): Promise<HonorJobResponse | null> {
  const parsedJobId = parseHonorJobId(jobId);

  if (parsedJobId === null) {
    return null;
  }

  return marketingApiGet<HonorJobResponse | null>({
    emptyValue: null,
    logContext: { jobId: parsedJobId },
    logMessage: "Failed to fetch Honor job details from hi-marketing-api",
    logTags: { component: "getHonorJob" },
    path: `/api/v1/honor/jobs/${parsedJobId}`,
    throwOnError: options.throwOnError,
  });
}

export { getHonorJob };
